export default __webpack_public_path__ + "static/media/Bg-8.3126e9ae.png";